import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const useContacts = ({ searchParam, pageNumber, date, dateStart, dateEnd }) => {
    const [loading, setLoading] = useState(true);
    const [hasMore, setHasMore] = useState(false);
    const [contacts, setContacts] = useState([]);
    const [count, setCount] = useState(0);

    useEffect(() => {
        setLoading(true);
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async () => {
                try {
                    // Verificar se há token antes de fazer a requisição
                    const token = localStorage.getItem("token");
                    if (!token) {
                        setLoading(false);
                        return;
                    }
                    
                    const { data } = await api.get("/contacts", {
                        params: {
                            searchParam,
                            pageNumber,
                            date,
                            dateStart,
                            dateEnd,
                            // Busca apenas no cadastro do contato. Sem isso o backend
                            // também varre o corpo das mensagens e traz qualquer contato
                            // que já tenha citado a palavra em alguma conversa.
                            searchScope: "contact",
                        },
                    });
                    // "Carregar mais" precisa somar à lista: antes o setContacts
                    // substituía tudo e as opções da página anterior sumiam.
                    setContacts(prev =>
                        +pageNumber === 1
                            ? data.contacts
                            : [
                                ...prev,
                                ...data.contacts.filter(
                                    c => !prev.some(p => p.id === c.id)
                                ),
                            ]
                    );

                    setHasMore(data.hasMore);
                    setCount(data.count);
                    setLoading(false);
                } catch (err) {
                    setLoading(false);
                    toastError(err);
                }
            };

            fetchContacts();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchParam, pageNumber, date, dateStart, dateEnd]);

    return { contacts, loading, hasMore, count };
};

export default useContacts;
